import axios from "axios";
import { showSuccess } from "../../notifications/actions/notificationActionCreators";
import { trackEvent } from "../../tracking/tracking";
import { changedSession, erroredCreateSession, fetchedSession, startedCreateSession } from "./sessionActionCreators";
import setCsrfMetaTags from "../../../assets/javascripts/lib/set_csrf_meta_tags";

const apiUrl = "/api/session";

export const source = {
  fetch() {
    return typeof window !== "undefined" && window !== null && window.Application != null ? window.Application.sessionInit : Promise.resolve();
  },
};

export const fetchSession = () =>
  dispatch => source.fetch().then(response => dispatch(fetchedSession(response)));

export const changeSession = () =>
  dispatch => source.fetch().then(response => dispatch(changedSession(response)));

export const createSession = (username, password) =>
  (dispatch) => {
    dispatch(startedCreateSession());

    const request = axios.post(apiUrl, { username, password }).then(({ data }) => data);
    window.Application.sessionInit = request;
    if (window.Application && window.Application.getSession) window.Application.getSession().initialize();
    return request
      .then((session) => {
        dispatch(changedSession(session));
        trackEvent("Sign-Up", "Login Success");
        window.Application.publish("session:login", session);
        return session;
      })
      .catch((error) => {
        if (error.response && error.response.status === 429) {
          dispatch(erroredCreateSession(
            "Da warst du zu schnell. Warte kurz und probiere es dann noch mal.",
          ));
        } else {
          dispatch(erroredCreateSession(error.response.data.error));
        }
        throw error;
      });
  };

export const destroySession = () =>
  (dispatch) => {
    const request = axios.delete(apiUrl).then(({ data }) => data);
    window.Application.sessionInit = request;
    if (window.Application && window.Application.getSession) window.Application.getSession().initialize();
    return request
      .then((session) => {
        setCsrfMetaTags();
        dispatch(changedSession(session));
        trackEvent("Sign-Up", "Logout");
        window.Application.publish("session:logout", session);
        dispatch(showSuccess({ message: "Du hast dich erfolgreich ausgeloggt." }));
      });
  };
